import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SearchMode } from '@boma/client-shared';
import {
  IInventorySellerProduct,
  IProduct,
} from '@boma/supplier-portal/shared/entities';
import { SearchService } from '@boma/supplier-portal/shared/services';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';

@Component({
  selector: 'boma-stock-product-selector',
  templateUrl: './stock-product-selector.component.html',
  styleUrls: ['./stock-product-selector.component.scss'],
})
export class StockProductSelectorComponent implements OnInit, OnDestroy {
  products: IInventorySellerProduct[] = [];
  productSearchResults: IProduct[];
  productSearchSubject = new Subject<string>();
  productSearchObservable: Subscription;
  displayAddProductDialog: boolean = false;

  categoryIds: string[] = [];
  filters: { key: string; value: string }[] = [];
  @Input() operatingLocationId: string = null;
  supplierId: string = null;
  brandId: string = null;
  searchMode: SearchMode = SearchMode.AllEntityCatalogueProducts;

  @Input() resultsPerPage = '25';
  @Input() currentPage = '1';
  @Input() canEdit = true;
  @Input() entityId: string = null;
  @Input() initialProducts: IInventorySellerProduct[] | null = null;
  @Output() productsChanged = new EventEmitter<IInventorySellerProduct[]>();

  productFormGroup: FormGroup = new FormGroup({
    product: new FormControl(null, Validators.required),
    units: new FormControl(1, Validators.min(1)),
  });

  constructor(private searchService: SearchService) {}

  ngOnInit(): void {
    if (this.initialProducts) {
      this.products = JSON.parse(JSON.stringify(this.initialProducts)); // remove ref to immutable array
    }

    this.productSearchObservable = this.productSearchSubject
      .asObservable()
      .pipe(
        debounceTime(500),
        switchMap((searchterm) => {
          return this.searchService.searchProducts(
            this.entityId,
            searchterm,
            this.currentPage,
            this.resultsPerPage,
            this.categoryIds,
            this.filters,
            this.operatingLocationId,
            this.supplierId,
            this.brandId,
            this.searchMode
          );
        })
      )
      .subscribe((res) => {
        this.productSearchResults = res.items;
      });
  }

  searchProduct(event) {
    this.productSearchSubject.next(event.query);
  }

  addProduct() {
    const { product, units } = this.productFormGroup.value;
    if (!product || !product.id || !units || units <= 0) {
      return;
    }
    this.products.push({
      productId: product.id,
      product,
      units,
      id: null,
      maxUnits: 0,
      minUnits: 0,
      price: 0
    });
    this.productsChanged.emit(this.products);
    this.productFormGroup.patchValue({ product: null, units: 1 });

    this.displayAddProductDialog = false;
  }

  removeProduct(productId) {
    this.products = this.products.filter((p) => p.productId != productId);
    this.productsChanged.emit(this.products);
  }

  ngOnDestroy() {
    this.productSearchObservable?.unsubscribe();
  }
}
